import type { SupabaseClient } from '@supabase/supabase-js'
import type { LoadSession } from '@/modules/auth/use-cases'
import { AuthUserMapper } from '../mappers'

export class SupabaseLoadSessionRepository {
  constructor(private readonly client: SupabaseClient) {}

  execute: LoadSession = async () => {
    const { data, error } = await this.client.auth.getSession()
    if (error || !data.session) return null
    const { error: userError } = await this.client.auth.getUser()
    if (userError) {
      await this.client.auth.signOut()
      return null
    }
    return AuthUserMapper.toDomain(data.session)
  }
}
